/**
 * Safe localStorage JSON parsing to prevent page crashes from corrupted or invalid stored data.
 * Use for any JSON.parse(localStorage.getItem(...)) that runs during render or in effects.
 */
export function safeParseJson<T>(raw: string | null, fallback: T): T {
  if (raw === null || raw === undefined) return fallback;
  try {
    const parsed = JSON.parse(raw);
    return parsed as T;
  } catch {
    return fallback;
  }
}

export function safeLocalStorageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeReadJsonFromStorage<T>(key: string, fallback: T): T {
  return safeParseJson<T>(safeLocalStorageGet(key), fallback);
}
